import { ArrowRight, Moon, Sun } from 'lucide-react';
import { Link } from 'react-router-dom';
import klaxLogo from 'assets/images/klax-auth-logo.png';
import LanguageSelector from 'components/blocks/language-selector/language-selector';
import { useTheme } from 'components/core/theme-provider';
import { Button, buttonVariants } from 'components/ui/button';
import { DocsSearch } from './docs-search';

export function DocsTopNav() {
  const { resolvedTheme, setTheme } = useTheme();
  const isDark = resolvedTheme === 'dark';

  return (
    // Equal side columns keep the search bar centered on the page, not between uneven neighbours.
    <header className="grid h-16 shrink-0 grid-cols-[auto_1fr_auto] items-center gap-4 border-b border-border px-4 md:grid-cols-[1fr_minmax(0,28rem)_1fr] md:px-6">
      <Link to="/docs" className="flex shrink-0 items-center gap-2 justify-self-start">
        <img src={klaxLogo} alt="KLAX logo" className="h-14 w-14 object-contain" />
      </Link>

      <DocsSearch />

      <div className="flex shrink-0 items-center gap-1 justify-self-end sm:gap-2">
        <LanguageSelector variant="klax" />
        <Button
          variant="ghost"
          size="icon"
          aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
          onClick={() => setTheme(isDark ? 'light' : 'dark')}
        >
          {isDark ? <Sun className="size-4" /> : <Moon className="size-4" />}
        </Button>
        <Link
          to="/chat"
          aria-label="Back to app"
          className={buttonVariants({ variant: 'ghost', size: 'sm', className: 'gap-1' })}
        >
          <span className="hidden md:inline">Back to app</span>
          <ArrowRight className="size-4" />
        </Link>
      </div>
    </header>
  );
}
